/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
// eslint-disable-next-line jira/restricted/redux
// eslint-disable-next-line jira/restricted/redux
import type { Store } from 'redux';
import type PlanSettingsInfoType from '@jira/spa-apps__advanced-roadmaps-plan-settings/src/PlanSettingsPlanInfo.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';
import type {
	OwnProps,
	StateProps,
	DispatchProps,
} from '@jira/portfolio-3__portfolio/src/app-simple-plans/view/settings/details/types.tsx';

/**
 * Plan Settings - plan-info page
 */

export const LazyPlanSettingsPlanInfo: LazyComponent<
	({
		store,
		...props
	}: OwnProps &
		StateProps &
		DispatchProps & {
			store?: Store;
		}) => React.JSX.Element
> = // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
	lazyForPaint<typeof PlanSettingsInfoType>(
		() =>
			markAsProductBundleReady(
				import(
					/* webpackChunkName: "async-plan-settings-plan-info", jiraSpaEntry: "async-plan-settings-plan-info" */ '@jira/spa-apps__advanced-roadmaps-plan-settings/src/PlanSettingsPlanInfo.tsx'
				),
			),
		{ ssr: false },
	);

const AsyncPlanSettingsPlanInfo = (): React.JSX.Element => (
	<LazyPage
		Page={LazyPlanSettingsPlanInfo}
		pageId="plan-settings-plan-info"
		shouldShowSpinner={false}
	/>
);

export default AsyncPlanSettingsPlanInfo;
